<template>
  <div class="file-upload">
    <div v-for="(fileItem,index) in fileList" :key="fileItem.id" class="img-item fl">
      <div class="image-box" :style="{backgroundImage:'url('+fileItem.url+')'}"></div>
      <i class="el-icon-error icon-delete" @click="fileDelete(index)" v-if="!column.disabled"></i>
    </div>
    <el-upload
      v-show="column.limit>0 && column.limit > fileList.length"
      action="#"
      :show-file-list="false"
      list-type="picture-card"
      :v-show="!column.disabled"
      :limit="column.limit"
      :on-change="change"
      :http-request="uploadFile"
      :on-exceed="exceed"
      :on-success="onSuccess"
      :on-error="onError"
      :on-progress="onProgress"
      :before-upload="before">
      <i class="el-icon-plus"></i>
    </el-upload>
    <div class="cl"></div>
  </div>
</template>

<script>
  import COS from "cos-js-sdk-v5";
  import api from "@/config/api";

  export default {
    name: "fileTemplate",
    props: ['column'],
    data() {
      return {
        fileType: [],
        cos: null,
        fileList: []
      }
    },
    created() {
      this.fileType = this.$utils.fileType;
      this.init();
    },
    methods: {
      //所有子组件必有此方法为当前数据赋值
      setValue() {
        let formModel = this.$store.state[this.$utils.storeKeys.CURRENTFORM];
        this.dealFileData(formModel);
      },
      before(file) {
        var index = file.name.lastIndexOf(".");
        //获取后缀
        var ext = file.name.substr(index + 1).toLowerCase();
        if (this.column.type &&
          this.fileType[this.column.type].format &&
          this.fileType[this.column.type].format.indexOf(ext) == -1) {
          this.$message.warning(`文件格式必须为` + this.fileType[this.column.type].format.toString());
          return false;
        }
      },
      exceed() {
        this.$message.warning(`只允许上传${this.column.limit}个文件`);
      },
      fileDelete(index) {
        this.fileList.splice(index, 1);
      },
      change(file, fileList) {
        this.fileList = fileList;
        if (file.status === 'success') {
          // this.$message.success(`文件${file.name}上传成功`);
          this.$notify({
            type: "success",
            title: '上传操作',
            message: '文件' + file.name + '上传成功',
            showClose: false,
          });
        }
      },
      dealFileData(formModel) {
        let fileData = formModel[this.column.prop];
        if (!fileData) return;
        if (typeof(fileData) == 'string') {
          if (this.column.thumbnailUrl) {
            this.fileList = [{url: formModel[this.column.thumbnailUrl], response: fileData}]
          } else {
            let url = fileData;
            switch (this.column.type) {
              case this.fileType.video.value:
                url = fileData;
                break;
              case this.fileType.voice.value:
                url = '/static/voice.png';
                break
              case this.fileType.file.value:
                url = '/static/file.png';
                break
            }
            this.fileList = [{url: url, response: fileData}]
          }
        } else if (typeof(fileData) == 'object' && fileData.length) {
          fileData.map(item => {
            if (item.url) {
              this.fileList.push({url: item.url, response: item.url});
            }
            if (item.imageUrl) {
              this.fileList.push({url: item.imageUrl, response: item.imageUrl});
            }
          });
        }
      },
      //初始化
      init() {
        this.cos = new COS({
          getAuthorization: (options, callback) => {
            this.$axios.fetchPost(api.sign + "?method=POST").then(result => {
                let credentials = result.data && result.data.credentials;
                if (!result.data || !credentials) {
                  this.fileList.pop();
                  this.$message.error("cos签名错误");
                  return console.error('credentials invalid');
                }
                callback({
                  TmpSecretId: credentials.tmpSecretId,
                  TmpSecretKey: credentials.tmpSecretKey,
                  XCosSecurityToken: credentials.sessionToken,
                  // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
                  StartTime: result.data.startTime, // 时间戳，单位秒，如：1580000000
                  ExpiredTime: result.data.expiredTime, // 时间戳，单位秒，如：1580000900
                  ScopeLimit: true, // 细粒度控制权限需要设为 true，会限制密钥只在相同请求时重复使用
                });
              }
            )
          }
        });
      },
      //文件上传
      uploadFile(params) {
        let file = params.file;
        //修改文件名称，时间戳加上文件名称
        const timeStamp = new Date() - 0;
        file = new File([file], `${timeStamp}_${file.name}`);

        this.cos.putObject({
          Bucket: this.$utils.cos.bucket,
          Region: this.$utils.cos.region,
          Key: file.name,
          Body: file,
          onProgress: (progressData) => {
            params.onProgress(progressData)
          }
        }, (err, data) => {
          if (data && data.Location) {
            file.path = data.Location;
            params.onSuccess(data.Location);
          } else {
            params.onError(err)
          }
        });
      },
      //上传缩略图
      uploadVideoImgFile(item, file) {
        this.cos.putObject({
          Bucket: this.$utils.cos.bucket,
          Region: this.$utils.cos.region,
          Key: file.name,
          Body: file,
          onProgress: (progressData) => {
          }
        }, (err, data) => {
          if (data && data.Location) {
            item.url = `https://${data.Location}`;
            this.column.change && this.column.change(this.column, this.fileList);
          }
        });
      },
      onProgress(arg, file, fileList) {
      },
      onSuccess(arg, file, fileList) {
        fileList.map(item => {
          if (item.response == arg) {
            item.response = `https://${item.response}`;
            //判断是否是视频
            switch (this.column.type) {
              case this.fileType.video.value:
                item.url = '/static/video.png';
                break;
              case this.fileType.voice.value:
                item.url = '/static/voice.png';
                break
              case this.fileType.file.value:
                item.url = '/static/file.png';
                break
            }
            this.column.change && this.column.change(this.column, fileList);
          }
        });
        this.fileList = fileList;
      },
      onError(arg, file, fileList) {
        this.$message.error(`文件${file.name}上传失败`);
      },
      getFormData() {
        return this.fileList;
      },
      clearData() {
        this.fileList = [];
      },
    }
  }
</script>

<style>
  .file-upload {
    margin-bottom: 10px;
  }

  .el-upload-list .el-upload-list__item {
    background-image: url("/static/load.gif");
    background-size: 40px 40px;
    background-position: 20px 20px;
    background-repeat: no-repeat;
    width: 80px;
    height: 80px;
  }

  .el-upload--picture-card {
    width: 80px;
    height: 80px;
    line-height: 80px;
  }

  .file-upload .img-item {
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    border: 1px dashed #C0C4CC;
    border-radius: 5px;
    color: #C0C4CC;
    background-size: 100% 100%;
    position: relative;
    margin-right: 10px;
  }

  .file-upload .img-item .icon-delete {
    position: absolute;
    right: -4px;
    top: -4px;
    cursor: pointer;
  }

  .file-upload .img-item .image-box {
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/controls/fileTemplate.vue